// speciális, a belső componentek használ(hat)ják az ebben lévő styleokat, ezért ezt kötelezőp behuzni, nem csak mikor oda lepünk..
import PageNames from '../../constant/pageNames.js'

const Profile = () => import(/* webpackChunkName: "my-profile" */ '../../pages/profile/profile.vue')
const Helpdesk = () => import(/* webpackChunkName: "helpdesk" */ '../../pages/helpdesk/helpdesk.vue')
const Checkout = () => import(/* webpackChunkName: "checkout" */ '../../pages/checkout/checkout.vue')
const Search = () => import(/* webpackChunkName: "search" */ '../../pages/search/search.vue')
const ConfirmEmailChange = () => import(/* webpackChunkName: "confirm-email-change" */ '../../pages/confirm-email-change/confirm-email-change.vue')
const ConfirmSubscription = () => import(/* webpackChunkName: "ConfirmSubscription" */ '../../pages/ConfirmSubscription/ConfirmSubscription.vue')
const ConfirmProductOpinionUnsubscribe = () => import(/* webpackChunkName: "ConfirmProductOpinionUnsubscribe" */ '../../pages/ConfirmProductOpinionUnsubscribe/ConfirmProductOpinionUnsubscribe.vue')
const ConfirmMailMasterSubscribe = () => import(/* webpackChunkName: "ConfirmMailMasterSubscribe" */ '../../pages/ConfirmMailMasterSubscribe/ConfirmMailMasterSubscribe.vue')
const ConfirmMailMasterUnsubscribe = () => import(/* webpackChunkName: "ConfirmMailMasterUnsubscribe" */ '../../pages/ConfirmMailMasterUnsubscribe/ConfirmMailMasterUnsubscribe.vue')
const ListPage = () => import(/* webpackChunkName: "ListPage" */ '../../pages/ListPage/ListPage.vue')
const Login = () => import(/* webpackChunkName: "Login" */ '../../pages/login/login.vue')
const PasswordRecovery = () => import(/* webpackChunkName: "passwordRecovery" */ '../../pages/password-recovery/password-recovery.vue')
const ChangePassword = () => import(/* webpackChunkName: "changePassword" */ '../../pages/change-password/change-password.vue')
const articlePage = () => import(/* webpackChunkName: "articlePage" */ '../../pages/articlePage/articlePage.vue')
const productQuestions = () => import(/* webpackChunkName: "productQuestions" */ '../../pages/productQuestions/productQuestions.vue')
const productPage = () => import(/* webpackChunkName: "productPage" */ '../../pages/productPage/productPage.vue')
const productReviews = () => import(/* webpackChunkName: "productReviews" */ '../../pages/productReviews/productReviews.vue')
const productCompositions = () => import(/* webpackChunkName: "compositions" */ '../../pages/productCompositions/productCompositions.vue')
const home = () => import(/* webpackChunkName: "home" */ '../../pages/home/home.vue')
const mealComponent = () => import(/* webpackChunkName: "mealComponent" */ '../../pages/mealComponent/mealComponent.vue')
const thankYouNew = () => import(/* webpackChunkName: "thankYou" */ '../../pages/thankYou/thankYou.vue')
const Brands = () => import(/* webpackChunkName: "brands" */ '../../pages/brands/brands.vue')
const gallery = () => import(/* webpackChunkName: "gallery" */ '../../pages/gallery/gallery.vue')
const imagePage = () => import(/* webpackChunkName: "imagePage" */ '../../pages/imagePage/imagePage.vue')
const keywords = () => import(/* webpackChunkName: "keywords" */ '../../pages/keywords/keywords.vue')
const news = () => import(/* webpackChunkName: "news" */ '../../pages/news/news.vue')
const productTest = () => import(/* webpackChunkName: "productTest" */ '../../pages/productTest/productTest.vue')
const LeadSubscriber = () => import(/* webpackChunkName: "LeadSubscriber" */ '../../pages/LeadSubscriber/LeadSubscriber.vue')
const UserEmailValidation = () => import('../../pages/userEmailValidation/userEmailValidation.vue')
const ReturnClothing = () => import('../../pages/ReturnClothing/ReturnClothing.vue')

/**
 * üres title kell, hogy ne undefined legyen, mert az figyelve van, ugyis nem Vue oldalon az undefined
 * és nincs cserélve, azért nem a title i18n van benne csak "", mert itt még nincs i18n load
 * beforeRoute már van
 *
 * ha a name === null, akkor a slotban lévő content fog megjelenni
 */
const routeList = [
  {
    path: '/',
    name: PageNames.PAGE_HOME,
    component: home,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/news',
    name: PageNames.PAGE_NEWS,
    component: news,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/gallery',
    name: PageNames.PAGE_GALLERY,
    component: gallery,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/keywords',
    name: PageNames.PAGE_KEYWORDS,
    component: keywords,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/image',
    name: PageNames.PAGE_IMAGE,
    component: imagePage,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/:slug*-:itemType(a|l):id(\\d+)',
    name: PageNames.PAGE_ARTICLE,
    component: articlePage,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'article',
        needInstance: true,
        instanceType: PageNames.PAGE_ARTICLE,
      },
    },
  },
  {
    path: '/:slug*-mc:id(\\d+)',
    name: PageNames.PAGE_MEAL_COMPONENT,
    component: mealComponent,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'meal_component',
        needInstance: true,
        instanceType: PageNames.PAGE_MEAL_COMPONENT,
      },
    },
  },
  {
    path: '/:slug*-pt:id(\\d+)',
    name: PageNames.PAGE_PRODUCT_TEST,
    component: productTest,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/:slug*-p:id(\\d+)/compositions',
    name: PageNames.PAGE_PRODUCT_COMPOSITIONS,
    component: productCompositions,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: PageNames.PAGE_PRODUCT_COMPOSITIONS,
        needInstance: true,
        instanceType: 'product',
      },
    },
  },
  {
    path: '/:slug*-p:id(\\d+)/questions',
    name: PageNames.PAGE_PRODUCT_QUESTIONS,
    component: productQuestions,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: PageNames.PAGE_PRODUCT_QUESTIONS,
        needInstance: true,
        instanceType: 'product',
      },
    },
  },
  {
    path: '/:slug*-p:id(\\d+)/reviews',
    name: PageNames.PAGE_PRODUCT_REVIEWS,
    component: productReviews,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: PageNames.PAGE_PRODUCT_REVIEWS,
        needInstance: true,
        instanceType: 'product',
      },
    },
  },
  {
    path: '/:slug*-:itemType(p|q):id(\\d+)',
    name: PageNames.PAGE_PRODUCT_PRODUCT,
    component: productPage,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: PageNames.PAGE_PRODUCT_PRODUCT,
        needInstance: true,
        instanceType: 'product',
      },
    },
  },
  {
    path: '/:slug*-c:id(\\d+)',
    name: PageNames.PAGE_CATEGORY,
    component: ListPage,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'list',
        needInstance: true,
        instanceType: PageNames.PAGE_CATEGORY,
      },
    },
  },
  {
    path: '/:slug*-b:id(\\d+)',
    name: PageNames.PAGE_BRAND,
    component: ListPage,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'brands',
        needInstance: true,
        instanceType: PageNames.PAGE_BRAND,
      },
    },
  },
  {
    path: '/search',
    name: PageNames.PAGE_SEARCH,
    component: Search,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'search',
      },
    },
  },
  {
    path: '/confirmSubscription',
    name: PageNames.PAGE_CONFIRM_SUBSCRIPTION,
    component: ConfirmSubscription,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/leadSubscriber',
    name: PageNames.PAGE_LEAD_SUBSCRIBER,
    component: LeadSubscriber,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/changePassword',
    name: PageNames.PAGE_CHANGE_PASSWORD,
    component: ChangePassword,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: true,
      redirectLoggedIn: '/profile',
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/passwordRecovery',
    name: PageNames.PAGE_PASSWORD_RECOVERY,
    component: PasswordRecovery,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: true,
      redirectLoggedIn: '/profile',
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'passwordrecovery',
      },
    },
  },
  {
    path: '/login',
    name: PageNames.PAGE_LOGIN,
    component: Login,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: true,
      redirectLoggedIn: '/profile',
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'login',
      },
    },
  },
  {
    path: '/confirmEmailChange',
    name: PageNames.PAGE_CONFIRM_EMAIL_CHANGE,
    component: ConfirmEmailChange,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/confirmMailMasterSubscribe',
    name: PageNames.PAGE_CONFIRM_MAIL_MASTER_SUBSCRIBE,
    component: ConfirmMailMasterSubscribe,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/confirmProductOpinionUnsubscribe',
    name: PageNames.PAGE_CONFIRM_PRODUCT_OPINION_EMAIL_UNSUBSCRIBE,
    component: ConfirmProductOpinionUnsubscribe,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/confirmMailMasterUnsubscribe',
    name: PageNames.PAGE_CONFIRM_MAIL_MASTER_UNSUBSCRIBE,
    component: ConfirmMailMasterUnsubscribe,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/checkout',
    name: PageNames.PAGE_CHECKOUT,
    component: Checkout,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'rendel',
      },
    },
  },
  {
    path: '/helpdesk',
    name: PageNames.PAGE_HELPDESK,
    component: Helpdesk,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: true,
      redirectLoggedIn: '/profile?tab=messages',
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: 'helpdesk',
      },
    },
  },
  {
    path: '/profile',
    name: PageNames.PAGE_PROFILE_MY_PROFILE,
    component: Profile,
    meta: {
      protectedRoute: true, // csak belépett userrel elérhető oldalak!
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/thank_you',
    name: PageNames.PAGE_THANK_YOU,
    component: thankYouNew,
    meta: {
      protectedRoute: false,
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/brands',
    name: PageNames.PAGE_BRANDS,
    component: Brands,
    meta: {
      protectedRoute: false,
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: true,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/userEmailValidation',
    name: PageNames.PAGE_USER_EMAIL_VALIDATION,
    component: UserEmailValidation,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: false,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  },
  {
    path: '/returnClothing',
    name: PageNames.PAGE_RETURN_CLOTHING,
    component: ReturnClothing,
    meta: {
      protectedRoute: false, // ez elérhető nem belépve is
      onlyLoggedOut: true,
      title: '',
      changeBreadCrumb: false,
      breadCrumbData: {
        pageName: '',
      },
    },
  }
]

export default routeList
